import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useLocalization } from "@/plugins/i18n";
import { computed } from "vue";
import { OnlsLangSwitcher } from "onls-core";


export default /*#__PURE__*/_defineComponent({
  __name: 'language-switcher',
  setup(__props) {

const otherLocales = computed(() =>
  availableLocales.filter((item) => item !== locale.value)
);

const { locale, availableLocales, setLocale } = useLocalization();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(OnlsLangSwitcher), {
    locale: _unref(locale),
    "other-locale": otherLocales.value,
    "onUpdate:locale": _unref(setLocale)
  }, null, 8, ["locale", "other-locale", "onUpdate:locale"]))
}
}

})